import React, { useEffect, useState } from "react";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Reset_Password_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import "./Reset_Password_Modal.css";
import { useDispatch, useSelector } from "react-redux";
import { sendMobileOtp, verifyOtp } from "../../../../features/auth/authSlice";
import { red } from "@mui/material/colors";
import { appSetup } from "../../../../features/master/masterSlice";
import { RegxExpression } from "../../../../utils/common";

const Reset_Password_Modal = ({
  email,
  contact,
  setContact,
  setEmail,
  ...props
}) => {
  const {
    control,
    register,
    reset,
    setError,
    handleSubmit,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm();
  const [otp, setOtp] = useState(["", "", "", ""]);
  // const [email, setEmail] = useState('');
  // const [contact, setContact] = useState('');
  const [showOtpDiv, setShowOtpDiv] = useState(false);
  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value) || value.length > 1) {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Focus the next input field
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  // const data = {};
  const dispatch = useDispatch();

  const [timer, setTImer] = useState(0);
  const [disabled, setDisables] = useState(false);

  // const onSubmit = async (user) => {
  //   const validator = require("validator");

  //   if (validator.isEmail(user.email)) {
  //     console.log("The email address is valid.");
  //     setEmail(user.email);
  //     data.email = user.email;
  //   } else {
  //     console.log("The email address is invalid.");
  //     setContact(user.email);
  //     data.contact_no = user.email;
  //   }
  //   const res = await dispatch(sendMobileOtp(data));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     setTImer(90);
  //     setShowOtpDiv(true);
  //   } else if (res.meta?.requestStatus === "rejected") {
  //     setError("email", {
  //       type: "custom",
  //       message: "Email Address / Mobile  Number not Found",
  //     });
  //   }
  // };

  const onSubmit = async (user) => {
    const validator = require("validator");

    const value = user.email.trim();

    // Clear previous backend error
    clearErrors("email");

    const data = {};

    if (validator.isEmail(value)) {
      setEmail(value);
      setContact("");
      data.email = value;
    } else if (/^[6-9][0-9]{9}$/.test(value)) {
      setContact(value);
      setEmail("");
      data.contact_no = value;
    } else {
      setError("email", {
        type: "manual",
        message: "Please enter a valid email or 10 digit mobile number",
      });
      return;
    }

    const res = await dispatch(sendMobileOtp(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setTImer(90);
      setDisables(true);
      setShowOtpDiv(true);
      setOtp(["", "", "", ""]);
      clearErrors("otp");
    } else if (res.meta?.requestStatus === "rejected") {
      const errors = res.payload?.errors;

      if (errors?.email) {
        setError("email", {
          type: "manual",
          message: errors.email,
        });
      }

      if (errors?.contact_no) {
        setError("email", {
          type: "manual",
          message: errors.contact_no,
        });
      }
    }
  };

  const [showSignUp, setShowSignUp] = useState(false);
  const validateOTp = async () => {
    if (timer <= 0) {
      setError("otp", {
        type: "manual",
        message: "OTP has expired. Please request a new OTP.",
      });
      return;
    }

    const enteredOtp = otp.join("");

    if (enteredOtp.length !== 4) {
      setError("otp", {
        type: "manual",
        message: "OTP is required",
      });
      return;
    }

    const data = {
      email: email,
      contact_no: contact,
      otp: enteredOtp,
    };

    const verify = await dispatch(verifyOtp(data));

    if (verify.meta?.requestStatus === "fulfilled") {
      props?.onHide();
      props?.setShowSetPassModal();
      setShowOtpDiv(false);
      setOtp(["", "", "", ""]);
    } else if (verify.meta?.requestStatus === "rejected") {
      setError("otp", {
        type: "custom",
        message:
          verify.payload?.errors || verify.payload?.message || "Invalid OTP",
      });
    }
  };

  const handleKeyDown = async (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  useEffect(() => {
    if (!disabled || timer <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setTImer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setDisables(false);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [disabled, timer]);

  const resendCode = async () => {
    if (disabled) return;

    const data = {};

    if (email) {
      data.email = email;
    } else if (contact) {
      data.contact_no = contact;
    }

    const res = await dispatch(sendMobileOtp(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setOtp(["", "", "", ""]);
      clearErrors("otp");
      setTImer(90);
      setDisables(true);
    }
  };

  const app_setup = useSelector((state) => state.master.app_setup);

  // useEffect(() => {
  //   dispatch(appSetup());
  // }, [dispatch]);

  const handleClose = () => {
    reset();
    clearErrors();

    setEmail("");
    setContact("");

    setOtp(["", "", "", ""]);
    setShowOtpDiv(false);

    setTImer(0);
    setDisables(false);

    props?.onHide();
  };

  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  return (
    <Modal
      className="Reset_Password_Modal Login_Modal"
      size="md"
      {...props}
      onHide={handleClose}
      centered
    >
      <div className="absolute_div">
        <div className="logo_holder">
          <img
            // src="/assets/images/logo/new_ekansi_logo.png"
            src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
            className="logo_img"
          />
        </div>
      </div>

      <Modal.Body>
        {!showOtpDiv && (
          <div className="reset_pass_main_form">
            <div className="close_img_div">
              <div className="title_div">
                <p className="title">Reset Your Password</p>
                <p className="sub_text">
                  Check your email for a password reset link
                </p>
              </div>
              <img
                src="/assets/images/modal/close.png"
                className="close_img"
                onClick={handleClose}
              />
            </div>

            <div className="reset_pass_div login_div">
              <div className="login_form_div">
                <Form>
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Email / Mobile Number</Form.Label>

                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Enter Email / Mobile Number"
                      // {...register("email", {
                      //   required: "Email / Mobile Number is required",
                      //   pattern: {
                      //     value: RegxExpression.email,
                      //     message: "Invalid email ",
                      //   },
                      // })}
                      {...register("email", {
                        required: "Email or Mobile Number is required",

                        validate: (value) => {
                          const input = value.trim();

                          if (/^\d+$/.test(input)) {
                            return (
                              /^[6-9][0-9]{9}$/.test(input) ||
                              "Please enter a valid 10 digit mobile number"
                            );
                          }

                          return (
                            RegxExpression.email.test(input) ||
                            "Please enter a valid email address"
                          );
                        },

                        onChange: (e) => {
                          const value = e.target.value.replace(/\s/g, "");

                          clearErrors("email");

                          setValue("email", value, {
                            shouldValidate: true,
                            shouldDirty: true,
                          });
                        },
                      })}
                    />
                    {/* {msg && <p >Email / number Not found</p>} */}
                    {errors.email && (
                      <div style={{ color: "red" }}>{errors.email.message}</div>
                    )}
                  </Form.Group>
                </Form>
              </div>

              <div className="btns_holder">
                <Gray_Btn btnText={"Cancel"} onClick={handleClose} />
                <Green_btn
                  btnText={"Submit"}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
        )}

        {showOtpDiv && (
          <div className="otp_main_div">
            <div className="close_img_div">
              <div className="title_div">
                <p className="title">OTP has been Sent </p>
                <p className="title">to {email || contact}</p>
              </div>
              <img
                src="/assets/images/modal/close.png"
                className="close_img"
                onClick={handleClose}
              />
            </div>

            <div className="Otp-field-holder">
              <>
                {/* {(disabled) ? */}
                {otp.map((value, index) => (
                  <Form.Control
                    name="otp"
                    key={index}
                    type="text"
                    className="otp-field"
                    maxLength="1"
                    value={value}
                    id={`otp-${index}`}
                    onChange={(e) => handleInputChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </>
              {errors.otp && (
                <div style={{ color: "red" }}>{errors.otp.message}</div>
              )}
            </div>

            <div className="btns_holder">
              {/* {disabled ? (
                <>
                  <Green_btn btnText="Submit" onClick={() => validateOTp()} />
                  Resend Code in {timer} seconds
                </>
              ) : (
                <Green_btn btnText="Resend" onClick={() => resendCode()} />
              )} */}
              {timer > 0 ? (
                <>
                  <p style={{ color: timer <= 10 ? "red" : "inherit" }}>
                    Resend Code in {formatTimer(timer)}
                  </p>

                  <Green_btn
                    btnText={"Submit"}
                    onClick={() => {
                      validateOTp();
                    }}
                    disabled={timer <= 0}
                  />
                </>
              ) : (
                <p
                  className="link_text"
                  onClick={() => {
                    resendCode();
                  }}
                >
                  Resend OTP
                </p>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Reset_Password_Modal;
